import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import DatePicker from "react-datepicker";

export const VisuallyHiddenInput = styled("input")`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

export const UploadBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasFile",
})(({ theme, hasFile }) => ({
  border: `2px dashed ${hasFile ? "#0A1929" : theme.palette.primary.main}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  cursor: "pointer",
  backgroundColor: theme.palette.background.default,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  transition: "background-color 0.2s ease, border-color 0.2s ease",
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.primary.main,
  fontWeight: 500,
}));

export const StyledDatePicker = styled(DatePicker)(({ theme, error }) => ({
  width: "100%",
  height: "56px",
  padding: "0 14px",
  border: `1px solid ${
    error ? theme.palette.error.main : theme.palette.divider
  }`,
  borderRadius: theme.shape.borderRadius,
  fontSize: "1rem",
  fontFamily: theme.typography.fontFamily,
  "&:hover": {
    borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
  },
  "&:focus": {
    borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
    outline: "none",
  },
  "& .react-datepicker-popper": {
    zIndex: 9999,
  },
  "& .react-datepicker-wrapper": {
    width: "100%",
  },
})); 